import React, { useEffect, useState } from "react";
import { useRespuesta } from "../../../data/RespuestaContext";
import { SkeletonComponent } from "../../Loading/SkeletonComponent";

const ComponentFormEtapas = ({ color, PropuestasComponent }) => {
  const { respuesta } = useRespuesta();
  const [isLoading, setIsLoading] = useState(true);

  //Reacciona cuando cambia la respuesta
  useEffect(() => {
    const cbRespuesta = () => {
      console.log("respuesta", respuesta);
      setIsLoading(false);
    };
    if (respuesta) {
      cbRespuesta();
    }
  }, [respuesta]);

  return (
    <>
      {/* Si se encuentra cargando renderiza Skeleton */}
      {isLoading && <SkeletonComponent max={5} />}
      {/* Si el cargado termino renderiza el componente propuestas */}
      {!isLoading &&
        respuesta.propuestas.map((proyecto, index) => (
          <PropuestasComponent
            key={index}
            itemProyecto={proyecto}
            indexPropuesta={index}
            color={color}
          />
        ))}
    </>
  );
};

export default ComponentFormEtapas;
